import { Suspense } from "react";
import lazy from "@/utils/lazyWithReload";
import { Navigate, Outlet } from "react-router";
import { SvgIcon } from "@/components/icon";
import { CircleLoading } from "@/components/loading";
import type { AppRouteObject } from "#/router";
import NewVantageAIHomePage from "@/pages/NewVantageAIHomePage";
import PaymentGatewayRedirectScreen from "@/pages/PaymentGatewayRedirectScreen/PaymentGatewayRedirectScreen";
import PaymentStatusScreen from "@/pages/PaymentStatusScreen/PaymentStatusScreen";
import NewPlanUpgradeScreen from "@/pages/UpgradePlanScreen/NewPlanUpgradeScreen";
import PaymentErrorScreen from "@/pages/PaymentStatusScreen/PaymentErrorScreen";
import TransferDashboardsScreen from "@/pages/UpgradePlanScreen/TransferDashboardsScreen";
import TransferDashboardSuccessScreen from "@/pages/UpgradePlanScreen/TransferDashboardSuccessScreen";
import PaymentFailedErrorScreen from "@/pages/PaymentStatusScreen/PaymentFailedErrorScreen";
// import EnterPrisePaymentSuccessScreen from "@/pages/PaymentStatusScreen/EnterprisePaymentSuccessScreen";

const DashboardPlayground = lazy(() => import("@/pages/dashboard/dashboardPlayground/index.tsx"));
const DashboardsHome = lazy(() => import("@/pages/dashboard/dashboardsHome/index"));
const DashboardsCatch = lazy(() => import("@/pages/dashboard/Dashboards/DashboardCatchAll"));
const AccountPage = lazy(() => import("@/pages/management/user/account"));
const ProfilePage = lazy(() => import("@/pages/management/user/profile"));
const NewDashboardPage = lazy(() => import("@/pages/NewDashboardPage/index"));
const NewDashboardPowerBIPage = lazy(() => import("@/pages/PowerBIStyleDashboard/index"));
const SmartDashboardAgentPage = lazy(() => import("@/pages/FinalSmartDashboardAgent/index"));
const CleanWorkflowDashboardAgent = lazy(() => import("@/pages/CleanDashboardFlowAgentVersion3/index"));
const EnterPrisePaymentSuccessScreen = lazy(() => import("@/pages/PaymentStatusScreen/EnterprisePaymentSuccessScreen"));

const dashboard: AppRouteObject[] = [
	{
		order: 1,
		path: "dashboard",
		element: (
			<Suspense fallback={<CircleLoading />}>
				<Outlet />
			</Suspense>
		),
		meta: {
			label: "sys.menu.dashboard",
			icon: <SvgIcon icon="ic-analysis" className="ant-menu-item-icon" size="24" />,
			key: "/dashboard",
		},
		children: [
			{
				index: true,
				element: <Navigate to="/dashboard/home" replace />,
			},
			{
				path: "dashboardPlayground",
				element: <DashboardPlayground />,
				meta: {
					label: "Dashboard Playground",
					key: "/dashboard/dashboardPlayground",
					hideMenu: true,
				},
			},
			{
				path: "upgrade-plan",
				element: <NewPlanUpgradeScreen />,
				meta: {
					label: "Billing",
					key: "/dashboard/upgrade-plan",
				},
			},
			{
				path: "redirecting-to-payment-partner",
				element: <PaymentGatewayRedirectScreen />,
				meta: {
					label: "Checkout",
					key: "/dashboard/redirecting-to-payment-partner",
				},
			},
			{
				path: "waiting-for-payment-confirmation",
				element: <Navigate to="/payment/cancelled" replace />,
				meta: {
					label: "Waiting for Payment",
					key: "/dashboard/waiting-for-payment-confirmation",
					hideMenu: true,
				},
			},
			{
				path: "payment-error",
				element: <PaymentFailedErrorScreen />,
				meta: {
					label: "Payment",
					key: "/payment/error",
				},
			},
			
			{
				path: "transfer-dashboards",
				element: <TransferDashboardsScreen />,
				meta: {
					label: "Payment",
					key: "/dashboard/transfer-dashboards",
				},
			},
			{
				path: "transfer-dashboards-success",
				element: <TransferDashboardSuccessScreen />,
				meta: {
					label: "Payment",
					key: "/dashboard/transfer-dashboards-success",
				},
			},
			{
				path: "home",
				element: <NewVantageAIHomePage />,
				meta: {
					label: "Home",
					key: "/dashboard/home",
				},
			},
			{
				path: "new-dashboard",
				element: <NewDashboardPage />,
				meta: {
					label: "New Dashboard",
					key: "/dashboard/new-dashboard",
				},
			},
			{
				path: "new-dashboard-powerbi",
				element: <NewDashboardPowerBIPage />,
				meta: {
					label: "New Dashboard",
					key: "/dashboard/new-dashboard-powerbi",
				},
			},
			{
				path: "smart-dashboard-agent",
				element: <SmartDashboardAgentPage />,
				meta: {
					label: "Smart Dashboard",
					key: "/dashboard/smart-dashboard-agent",
				},
			},
			{
				path: "dashboard-playgrounds",
				element: <CleanWorkflowDashboardAgent />,
				meta: {
					label: "Home",
					key: "/dashboard/dashboard-playgrounds",
				},
			},
			{
				path: "legacy-dashboard-playgrounds",
				element: <DashboardsHome />,
				meta: {
					label: "Dashboard Playground",
					key: "/dashboard/legacy-dashboard-playgrounds",
					hideMenu: true,
				},
			},
		],
	},
	{
		path: "/dashboard/:dashboard_id/:dashboard_name",
		element: <DashboardsCatch />,
		meta: {
			label: "Dashboard",
			key: "/dashboard/:dashboard_id/:dashboard_name",
		},
	},
	{
		path: "/account",
		element: <AccountPage />,
		meta: {
			label: "sys.menu.user.account",
			key: "/account",
		},
	},
	{
		path: "/profile",
		element: <ProfilePage />,
		meta: {
			label: "sys.menu.user.profile",
			key: "/profile",
		},
	},
	{
				path: "/enterprise/payment/error",
				element: <PaymentFailedErrorScreen />,
				meta: {
					label: "Payment",
					key: "/enterprise/payment/error",
				},
			},
	{
		path: "/payment/success",
		element: <PaymentStatusScreen />,
		meta: {
			label: "Payment",
			key: "/payment/success",
		},
	},
		{
		path: "/enterprise/payment/success",
		element: <EnterPrisePaymentSuccessScreen />,
		meta: {
			label: "Payment",
			key: "/enterprise/payment/success",
		},
	},
	{
		path: "/payment/cancelled",
		element: <PaymentErrorScreen />,
		meta: {
			label: "Payment",
			key: "/payment/cancelled",
		},
	},
	{
		path: "/enterprise/payment/cancelled",
		element: <PaymentErrorScreen />,
		meta: {
			label: "Payment",
			key: "/enterprise/payment/cancelled",
		},
	},
];

export default dashboard;